import { useScrollAnimation } from "../../hooks/useScrollAnimation";

const stats = [
  {
    number: "2M+",
    label: "Data points processed",
  },
  {
    number: "15,078",
    label: "Homes analyzed",
  },
  {
    number: "1,281",
    label: "High-priority leads identified",
  },
  {
    number: "$22.3M",
    label: "Pipeline value surfaced",
  },
];

export const CaseStudySection = () => {
  const [headerRef, headerVisible] = useScrollAnimation();
  const [cardsRef, cardsVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <section
      className="py-24 px-[5%] border-t border-[#1e1e1e]"
      data-testid="case-study-section"
    >
      <div className="max-w-content mx-auto">
        <div
          ref={headerRef}
          style={{
            opacity: headerVisible ? 1 : 0,
            transform: headerVisible ? "translateY(0)" : "translateY(30px)",
            transition: "opacity 0.7s ease-out, transform 0.7s ease-out",
          }}
        >
          <p className="text-[0.7rem] font-semibold tracking-[3px] uppercase text-[#6b7280] mb-6">
            CASE STUDY
          </p>
          <h2 className="text-[clamp(1.75rem,3.5vw,2.5rem)] font-medium tracking-[-0.5px] leading-[1.3] text-white mb-16 max-w-4xl">
            In just one mid-sized US city, we analyzed 15,078 homes — and found{" "}
            <span className="text-[#3b82f6]">$22.3M in new siding replacement opportunity.</span>
          </h2>
        </div>

        <div ref={cardsRef} className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat, idx) => (
            <div
              key={idx}
              className="bg-[#141414] border border-[#1e1e1e] rounded-[12px] p-7 flex flex-col justify-start items-start min-h-[180px] text-left"
              data-testid={`case-study-stat-${idx}`}
              style={{
                opacity: cardsVisible ? 1 : 0,
                transform: cardsVisible ? "translateY(0)" : "translateY(20px)",
                transition: `opacity 0.6s ease-out ${0.1 + idx * 0.12}s, transform 0.6s ease-out ${0.1 + idx * 0.12}s`,
              }}
            >
              <p className="text-[clamp(2rem,4vw,3.5rem)] font-bold text-white tracking-[-1px] leading-none text-left">
                {stat.number}
              </p>
              <p className="text-[0.9rem] text-[#6b7280] mt-3 text-left">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
